import { endpoints } from "../../configs/Settings";
import { OAuthApplication } from "@/services/auth";
import { useAxios } from "../../utils/useAxios";
import { HTTPResponseStatus } from "../../utils/enum";
import { useAuth } from "../../utils/useAuth";

export async function PostWhereby(data: any) {
  const url = `${endpoints.WHEREBY}`;

  const headers = {
    Authorization:
      (await useAuth.getUserToken()) || (await OAuthApplication()),
    Accept: "application/json",
    "Content-Type": "application/json",
  };
  const response = await useAxios
    .post(url, data, { headers, timeout: 8000 })
    .then((response) => {
      if (
        response.status !== HTTPResponseStatus.Created &&
        response.status !== HTTPResponseStatus.Success
      ) {
        throw new Error(`PostWhereby: ${response.status}`);
      }
      return response.data;
    })
    .catch((error) => {
      console.error("PostWhereby", error);
      // toast.error(`Erro ao realizar o post do whereby`);
      throw new Error();
    });
  if (response) return response;
}
